export default __webpack_public_path__ + "static/media/tiping.6f8c6f52.svg";